import type { ClientState, FirstClassDocument, PartialDocument } from '../types';
import { LayoutMode } from '../types';
import { isDocumentWithPagination } from '../typeValidators';
// eslint-disable-next-line import/no-cycle
import { globalState } from './models';

// Check if a doc is in vertical or horizontal layout mode
// If you want to get the layout mode, use useDocLayoutMode instead
export default function checkIfDocumentIsInPaginatedMode(
  doc: PartialDocument<FirstClassDocument, 'category' | 'url' | 'isPaginatedMode' | 'source_specific_data'> | null,
  paginationOnByDefaultList: ClientState['readerSettings']['mobile']['paginationOnByDefaultList'] = globalState.getState()
    .client.readerSettings.mobile.paginationOnByDefaultList,
  horizontalPaginationOnByDefaultList: ClientState['readerSettings']['mobile']['horizontalPaginationOnByDefaultList'] = globalState.getState()
    .client.readerSettings.mobile.horizontalPaginationOnByDefaultList,
): boolean {
  if (!doc || !isDocumentWithPagination(doc)) {
    return false;
  }

  if (doc.source_specific_data?.layoutMode !== undefined) {
    return [
      LayoutMode.VerticalPagination,
      LayoutMode.HorizontalPagination,
    ].includes(doc.source_specific_data.layoutMode);
  }

  // Check old isPaginatedMode field for backwards compatibility
  if (doc.isPaginatedMode !== undefined) {
    return doc.isPaginatedMode;
  }

  return paginationOnByDefaultList.includes(doc.category) || horizontalPaginationOnByDefaultList.includes(doc.category);
}
